/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================= Breeze ======================= */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = 'slim';
var klevu_productsToShowInSlimLayout = 6;

klevu.beforeActivation("quick", function(data, scope){
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickProductBlockTitleHeaderCustom, 'klevuQuickProductBlockTitleHeader', true);
        box.getScope().template.setTemplate(klevuQuickProductBlockCustom, 'klevuQuickProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, 'klevuTemplateBase', true);
        box.getScope().template.setTemplate(klevuQuickTrendingProductBlockCustom, 'klevuQuickTrendingProductBlock', true);
        box.getScope().template.setTemplate(klevuQuickRecentViewedProductBlockCustom, 'klevuQuickRecentViewedProductBlock', true);
        box.getScope().template.setTemplate(klevuSearchPersonalizationsCustom, 'klevuSearchPersonalizations', true);
    });
});

klevu.modifyRequest("quick", function(data, scope) {
    klevu.each(data.request.current.recordQueries, function(key, query) {
        // Trending products query usually comes with id "trendingProducts"
        if (query.id === "trendingProducts") {
            klevu.setObjectPath(query, "settings.limit", 8); // limit to 8 products
        }
    });
});
/* ====================================================== */
/* ========== KLEVU QUICKSEARCH TARGET INJECTION ========= */
/* ====================================================== */

// Wait for the Klevu library to be ready
window._klvReady = window._klvReady || [];
window._klvReady.push(function(){
    console.log("✅ _klvReady fired, assigning QuickSearch target...");

    klevu({
        search: {
            // Tell Klevu to use this as the target for Quick Search results
            searchBoxTarget: document.querySelector("#klevu-quick-search-results"),
        }
    });

    // If Quick Search has already been initialized, rebuild it to use the new settings
    if (klevu.getObjectPath(klevu.settings, 'flags.bindLocalBoxes.build', false)) {
        console.log("♻️ Rebuilding QuickSearch with new target...");
        klevu.rebuild.quick();
    } else {
        console.log("ℹ️ QuickSearch not yet built, will attach automatically.");
    }
});

klevu.afterTemplateRender('quick', function (data, scope) {
    function setKlevuQuickPopupTopPositionVariable() {
        klevu.each(klevu.dom.find('.kuQuickSearchAutoCompleteLayout .klevuWrap'), function (key, currentElement) {
            const topPosition = currentElement.getBoundingClientRect().top;
            document.documentElement.style.setProperty('--klevuQuickPopupTopPosition', `${topPosition}px`);
        });
    }
    setKlevuQuickPopupTopPositionVariable();
    window.addEventListener('resize', setKlevuQuickPopupTopPositionVariable);
});
/* ============== QUICK SEARCH TEMPLATES =============== */

var klevuQuickProductBlockTitleHeaderCustom = `
<div class="klevuSuggestionHeading">
    <span class="klevuHeadingText"><%=helper.translate("Products")%></span>
    </div>
    <div class="klevuProductsViewAll">
    <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
    <a href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>" target="_parent"><%=helper.translate("View All")%></a>
</div>`;

var klevuQuickProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <a title="<%= updatedProductName %>" target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>"  class="klevuQuickProductInnerBlock trackProductClick kuTrackRecentView">
        <div class="klevuProductItemTop">
            <div class="klevuQuickImgWrap">
                <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
            </div>
        </div>
        <div class="klevuProductItemBottom">
            <div class="klevuQuickProductDescBlock">
            <!-- START CUSTOM TAG FLAG -->
        <% if (typeof dataLocal.tags === 'string') { 
             var tags = dataLocal.tags.split(',').map(function(tag){ return tag.toLowerCase().trim(); });
             var tagDisplayed = false;
        %>
            <% if (tags.includes("new arrivals") && !tagDisplayed) { %>
              <div class="custom-tag-badge">New!</div>
              <% tagDisplayed = true; %>
            <% } %>
            <% if (tags.includes("exclusive") && !tagDisplayed) { %>
              <div class="custom-tag-badge">FAO Exclusive</div>
              <% tagDisplayed = true; %>
            <% } %>
            <% if (tags.includes("movingfast") && !tagDisplayed) { %>
              <div class="custom-tag-badge">Selling Quickly!</div>
              <% tagDisplayed = true; %>
            <% } %>
            <% if (tags.includes("best seller") && !tagDisplayed) { %>
              <div class="custom-tag-badge">Best Seller</div>
              <% tagDisplayed = true; %>
            <% } %>
            <% if (tags.includes("backinstock") && !tagDisplayed) { %>
              <div class="custom-tag-badge">Back in Stock</div>
              <% tagDisplayed = true; %>
            <% } %>
        <% } %>
        <!-- END CUSTOM TAG FLAG -->
                <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
                    <div class="klevu-brand"><%= dataLocal.brand %></div>
                <% } %>
                <div title="<%= updatedProductName %>" class="klevuQuickProductName kuClippedOne"> <%= updatedProductName %> </div>
                <div class="klevu-desc-l2 kuClippedOne"> <%=dataLocal.shortDesc%> </div>
                <div class="klevuQuickProductDesc kuClippedOne">
                    <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
                </div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('quickProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                <% if(klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="klevuQuickProductPrice kuClippedOne">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                            <div class="klevuQuickSalePrice kuStartPrice">
                                <span class="klevuQuickPriceGreyText"><%=helper.translate("Starting at")%></span>
                                <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                            </div>
                        <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                            <span class="klevuQuickOrigPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                                <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                            </span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="klevuQuickSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                    </div>
                    <%=helper.render('searchResultProductVATLabelQuick', scope, data, dataLocal) %>
                    <% } %>
                <% } %>
                <%=helper.render('klevuQuickProductRating',scope,data,dataLocal) %>
            </div>
        </div>
        <div class="kuClearLeft"></div>
    </a>
    <%=helper.render('quickSearchProductAddToCart',scope,data,dataLocal) %>        
</li>`;

var klevuQuickTemplateBaseCustom = `
<% var noResultsClass = '';
    if(typeof data.query.productList !== 'undefined' && data.query.productList.result.length === 0){
        noResultsClass = 'klevu-no-results';
    }
%>
<div class="klevu-fluid kuPreventDocumentClick">
    <div id="klevuSearchingArea" class="klevuQuickSearchingArea <%=noResultsClass %>">
        <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
            <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_header_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>                    
                </section>
                <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <div class="klevuSuggestionsBlock">                            
                        <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                        <!-- Removed page suggestions -->
                        <!--<%=helper.render('klevuQuickPageSuggestions',scope) %>-->
                        <% if(data.showQuickFacetedLayoutCharLimitMessage == true) { %>
                            <% var quickFacetedLayoutMessage = (data.quickFacetedLayoutMinCharsTextValue) ? data.quickFacetedLayoutMinCharsTextValue : ""; %>
                            <% if(quickFacetedLayoutMessage != "") { %>
                                <span class="kuFacetedLayoutMinCharText"><%= helper.translate(quickFacetedLayoutMessage) %></span>
                            <% } %>                    
                        <% } else { %>
                            <% if(data.query.productList) { %>
                                <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                                <%= helper.render('klevuQuickTemplateTabResults',scope) %>                                                 
                                <%= helper.render('klevuQuickProducts',scope) %>
                                <%= helper.render('klevuQuickOtherContent',scope) %>
                            <% } else { %>              
                                <div class="kuSearchPersonalizationsContainer">
                                    <%= helper.render('klevuSearchPersonalizations',scope) %>    
                                </div>
                            <% } %>  
                        <% } %>
                        <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    </div>
                </section>
            </header>
        
            <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                <section ku-block data-block-id="ku_quick_main_footer_banner">
                    <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                </section>
            </footer> 
        </div>
    </div>
</div>`;

var klevuQuickTrendingProductBlockCustom = `
<% 
var updatedProductName = dataLocal.name;
if(typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') {
    updatedProductName = updatedProductName.replace(dataLocal.brand, '');
}
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuQSMenuItemTarget kuTrackRecentView">
<div class="klevuProductItemTop">
    <div class="klevuQuickImgWrap">
        <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
        <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
    </div>
</div>
<div class="klevuProductItemBottom">
    <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
        <div class="klevu-brand"><%= dataLocal.brand %></div>
    <% } %>
    <div class="klevuQuickProductDescBlock">
        <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
        <div class="klevuQuickProductDesc">
            <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div>
            <div class="klevuQuickProductPrice">
            <%
                var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
            %>
            <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                <div class="klevuQuickSalePrice kuStartPrice">
                    <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                    <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                </div>
            <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                <span class="klevuQuickOrigPrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
                <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                    <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                </span>
            <% } else if(!Number.isNaN(kuSalePrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                </span>
            <% } else if(!Number.isNaN(kuPrice)) { %>
                <span class="klevuQuickSalePrice">
                    <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                </span>
            <% } %>
        </div>
        </div>                
    </div>
</div>        
</a>`;

var klevuQuickRecentViewedProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<a target="_self" href="<%=dataLocal.url%>" data-id="<%=dataLocal.id%>" class="klevuQuickProductInnerBlock kuTrackPersonalizedProductClick kuTrackRecentView kuQSMenuItemTarget">
    <div class="klevuProductItemTop">
        <div class="klevuQuickImgWrap">
            <div class="klevuQuickDiscountBadge"><strong><%=dataLocal.stickyLabelHead%></strong></div>
            <img src="<%=dataLocal.image.replace('_medium', '_300x300')%>" origin="<%=dataLocal.image.replace('_medium', '_300x300')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" />
        </div>
    </div>
    <div class="klevuProductItemBottom">
        <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
            <div class="klevu-brand"><%= dataLocal.brand %></div>
        <% } %>
        <div class="klevuQuickProductDescBlock">
            <div class="klevuQuickProductName kuClippedOne" title="<%= updatedProductName %>"><%= updatedProductName %></div>
            <div class="klevuQuickProductDesc">
                <div class="klevuSpectxt"><%=dataLocal.summaryAttribute%><span><%=dataLocal.stickyLabelText%></span></div> <div class="klevuQuickProductPrice">
                <%
                    var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                    var kuStartPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.startPrice,dataLocal.currency);
                    var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                    var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                %>
                <% if(!Number.isNaN(kuTotalVariants) && !Number.isNaN(kuStartPrice)) { %>                                
                    <div class="klevuQuickSalePrice kuStartPrice">
                        <span class="klevuQuickPriceGreyText"><%=helper.translate("From")%></span>
                        <span><%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.startPrice))%></span>                                
                    </div>
                <% } else if(!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && (kuPrice > kuSalePrice)){ %>
                    <span class="klevuQuickOrigPrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                    <span class="klevuQuickSalePrice klevuQuickSpecialPrice">
                        <%=helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice))%>
                    </span>
                <% } else if(!Number.isNaN(kuSalePrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                    </span>
                <% } else if(!Number.isNaN(kuPrice)) { %>
                    <span class="klevuQuickSalePrice">
                        <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                    </span>
                <% } %>
            </div>
            </div>                
        </div>
    </div>        
</a>`;

var klevuSearchPersonalizationsCustom = `
<div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
<section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
    <div ku-block data-block-id="ku_quick_left_facets"></div>
    <div ku-block data-block-id="ku_quick_left_call_outs">
        <%=helper.render('kuTemplatePopularSearches',scope) %>
        <%=helper.render('kuTemplateRecentSearches',scope) %>
    </div>
    <% if (window.innerWidth >= 768) { %>
        <div ku-block data-block-id="ku_quick_left_banner"></div>
    <% } %>
</section>
<section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
    <header ku-block data-block-id="ku_quick_result_header"></header>
    <div ku-block data-block-id="ku_quick_result_items"></div>
                
    <div ku-block data-block-id="ku_quick_other_items">
        <%=helper.render('klevuTrendingProducts',scope) %>
        <% if (window.innerWidth < 768) { %>
            <div ku-block data-block-id="ku_quick_left_banner"></div>
        <% } %>
        <%=helper.render('klevuRecentViewedProducts',scope) %>
    </div>

    <footer ku-block data-block-id="ku_quick_result_footer"></footer>
</section>
<section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
    <div ku-block data-block-id="ku_quick_right_facets"></div>
    <div ku-block data-block-id="ku_quick_right_call_outs"></div>
    <div ku-block data-block-id="ku_quick_right_banner"></div>
</section>
</div>`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ====================== Cascade ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu({
    theme: {
        setHelpers: {
            "catnav,landing": {
                isScreenWidthSmaller: function (screenWidth) {
                    // use in JS: scope.kScope.template.getHelpers().isScreenWidthSmaller()
                    // use in templates: <% helper.isScreenWidthSmaller() %>
                    if (!screenWidth) screenWidth = 767;
                    var widthOfScreen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    return widthOfScreen <= screenWidth;
                }
            }
        }
    }
});

klevu.beforeActivation("catnav,landing", function (data, scope) {

    scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);
    scope.kScope.template.setTemplate(klevuLandingTemplatePaginationCustom, 'pagination', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateProductBlockCustom, 'productBlock', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateSortByCustom, 'sortBy', true);


    scope.kScope.chains.events.keyUp.remove({
        name: "scrollToTop"
    });

    (function (klevu) {
        klevu.extend(true, klevu.search.modules, {
            addParamsToURL: {
                base: {
                    addURLtoHistory: function (data, scope, queryId) {
                        // Global stuff
                        if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                            console.error("This browser does not have the support of window.history or window.history.pushState");
                            return;
                        }

                        var searchPath = new URLSearchParams(window.location.search);
                        var currentSearchPath;
                        var previousSearchPath = searchPath.toString();

                        // this is in case we're running our code where we dont have context.activeQueryId
                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                        if (queryId && queryId.length) {
                            activeQueryId = queryId;
                        }

                        // Check if there any filter selected
                        let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                        let isThereFiltersSelected = false;
                        // Check if applyFilters is an object (but not an array), and not empty
                        if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                            isThereFiltersSelected = true;
                        }

                        // PAGINATION TO URL
                        var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                        var paginationQueryParam = "Page";
                        var currentPage = 0;

                        if (hasPaginationEnabled) {
                            var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                            if (activeQueryMeta) {
                                var productListLimit = activeQueryMeta.noOfResults;
                                currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                            }

                            if (currentPage === 0 || currentPage === 1) {
                                searchPath.delete(paginationQueryParam);
                            } else {
                                searchPath.set(paginationQueryParam, currentPage);
                            }

                            currentSearchPath = searchPath.toString();
                        };

                        // FILTERS TO URL
                        var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                        var filterValuesQueryParam = "";

                        if (activeQueryFilters) {
                            klevu.each(activeQueryFilters, function (key, filter) {
                                var selectedFilterKeyString = "";
                                var filterOptions = filter.options;
                                var selectedValues = "";

                                if (filterOptions && filterOptions.length) {
                                    klevu.each(filterOptions, function (key, option) {
                                        if (option.selected === true) {
                                            if (selectedValues.length) {
                                                selectedValues += ",";
                                            }
                                            selectedValues += option.value;
                                        }
                                    });
                                } else if (filter.type === "SLIDER") {
                                    var startValue = filter.start;
                                    var endValue = filter.end;
                                    var minValue = filter.min;
                                    var maxValue = filter.max;
                                    if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                        if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                            // just skipping
                                        } else {
                                            selectedValues = startValue + "-" + endValue;
                                        }
                                    }
                                }

                                if (selectedValues.length) {
                                    // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                    selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                }

                                if (selectedFilterKeyString.length) {
                                    if (filterValuesQueryParam.length) {
                                        filterValuesQueryParam += ";";
                                    }
                                    filterValuesQueryParam += selectedFilterKeyString;
                                }
                            });
                        }

                        if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                            searchPath.set("Filters", filterValuesQueryParam);
                        } else {
                            searchPath.delete("Filters");
                        }

                        currentSearchPath = searchPath.toString();

                        // ==============================
                        // Final URL change
                        if (previousSearchPath !== currentSearchPath) {
                            var historyState = { page: currentPage, filters: currentSearchPath };
                            window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                        }
                    },

                    restoreSearchParamsOnPageLoad: function (data, scope) {
                        var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                        if (hasAlreadyTriggered) return;

                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

                        var matchedQueryParamId = "";
                        var matchedQueryParamValue = "";
                        var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id) {
                                    if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                        matchedQueryParamId = recordQuery.id;
                                        matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                    }
                                }
                            });
                        }

                        klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

                        matchedQueryParamId = activeQueryId || "productList";

                        if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                            activeQueryId = matchedQueryParamId;
                            var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                            if (storage.tabs) {
                                storage.tabs.setStorage("local");
                                storage.tabs.mergeFromGlobal();
                                storage.tabs.addElement("active", activeQueryId);
                                storage.tabs.mergeToGlobal();
                            }
                        }

                        if (paginationFromURL && paginationFromURL > 1) {
                            if (recordQueries && recordQueries.length) {
                                klevu.each(recordQueries, function (key, recordQuery) {
                                    if (recordQuery.id === activeQueryId) {
                                        var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                        limit = Number(limit);
                                        if (limit > 0) {
                                            var expectedOffset = (paginationFromURL - 1) * limit;
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                        }
                                    }
                                });
                            }
                        }

                        // FILTERS
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            if (facets) {
                                klevu.each(facets, function (key, facet) {
                                    var splitFacet = facet.split(":");
                                    if (splitFacet.length) {
                                        var facetKey = decodeURIComponent(splitFacet[0]);
                                        var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                        var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                                        if (applyFilters && applyFilters.length) { // if there're some filters
                                            var isExistingKey = false;
                                            klevu.each(applyFilters, function (key, applyFilter) {
                                                if (applyFilter.key === facetKey) {
                                                    isExistingKey = true;
                                                    klevu.each(facetValues, function (key, facetValue) {
                                                        var isFilterOptionMatched = false;
                                                        klevu.each(applyFilter.values, function (key, value) {
                                                            if (facetValue === value) {
                                                                isFilterOptionMatched = true;
                                                            }
                                                        });
                                                        if (!isFilterOptionMatched) {
                                                            applyFilter.values.push(facetValue);
                                                        }
                                                    });
                                                }
                                            });
                                            if (!isExistingKey) {
                                                applyFilters.push({ key: facetKey, values: facetValues });
                                            }
                                        } else {
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                        }

                                    }
                                });
                            }
                        }
                    },

                    updatePayloadOnPopState: function (data, scope, activeQueryId) {
                        // SET PAGINATION PAYLOAD
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                        paginationFromURL = Number(paginationFromURL);
                        var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
                        limit = Number(limit);
                        if (limit > 0) {
                            var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                            // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                        }

                        // SET FILTER PAYLOAD
                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            // loop through all facets to get its values
                            let facetKey = '';
                            let facetValues = [];
                            let facetsArray = [];

                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    facetKey = decodeURIComponent(splitFacet[0]);
                                    facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                    facetsArray.push({ key: facetKey, values: facetValues });
                                }
                            });
                            // set the payload with correct filters:
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                        } else { // reset filters if Back button pressed, and there's no filters
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                        }
                    }
                },
                build: true
            },
            smoothScrollToProductListingTop: function () {
                let customOffset = 150;
                const selectorsToTriggerScrollToTop = {
                pagination: '.kuPagination a',
                // filterOptions: '.klevuFilterOption',
                // Add more selectors here as needed
                }
                function _smoothScrollToKlevuTop() {
                setTimeout(function () {
                    var target = document.getElementsByClassName('klevuMeta')[0];
        
                    if (target) {
                        var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
        
                        window.scrollTo({
                            top: topPosition - customOffset,
                            behavior: 'smooth'
                        });
                    }
                }, 200);
                }
                Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
                });
            },
            collapseAllFilters: function () {
                const selectors = {
                    kuFilterBox: '.kuFilterBox',
                    kuSelected: '.kuSelected',
                    kuFilterNames: '.kuFilterNames',
                    kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
                    kuFilterHead: '.kuFilterHead',
                    kuFilterHeadExpand: '.kuFilterHead.kuExpand',
                    kuExpand: '.kuExpand',
                    kuCollapse: '.kuCollapse',
                    nouiElement: '.noUi-origin',
                    priceFacetBlock: '[data-filter="klevu_price"]',
                    kuFilterShowAll: '.kuFilterShowAll',
                    kuFilterCollapse: '.kuFilterCollapse',
                };
                /** Collapse Filters by default */
                // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
                const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
                kuFilterHeadElements.forEach(element => {
                    element.classList.add(selectors.kuExpand.substring(1));
                    element.classList.remove(selectors.kuCollapse.substring(1));
                });
    
                // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
                const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);
                kuFilterNamesElements.forEach(element => {
                    element.classList.add(selectors.kuFilterCollapse.substring(1));
                    element.classList.remove(selectors.kuFilterShowAll.substring(1));
                });
            },
            keepFacetsWithSelectedOptionsOpened: function () {
                const selectors = {
                    kuFilterBox: '.kuFilterBox',
                    kuSelected: '.kuSelected',
                    kuFilterNames: '.kuFilterNames',
                    kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
                    kuFilterHead: '.kuFilterHead',
                    kuFilterHeadExpand: '.kuFilterHead.kuExpand',
                    kuExpand: '.kuExpand',
                    kuCollapse: '.kuCollapse',
                    nouiElement: '.noUi-origin',
                    priceFacetBlock: '[data-filter="klevu_price"]',
                    kuFilterShowAll: '.kuFilterShowAll',
                    kuFilterCollapse: '.kuFilterCollapse',
                };
        
                // Regular checkbox-facets
                // Check if the required elements exist
                const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
                if (kuSelectedElements.length > 0) {
                    kuSelectedElements.forEach(selectedElement => {
                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);
        
                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
        
                        // Rotate icon in the title 
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }
        
                        // Find the parent element with the class kuFilterNames.kuFilterCollapse
                        const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);
        
                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }
                    });
                }
        
                    // Price slider facet
                    var isThereAnyAppliedFacets = klevu.getObjectPath(
                        scope.kScope.data,
                        "localOverrides.query." +
                        scope.kScope.data.context.activeQueryId +
                        ".filters.applyFilters.filters"
                    );
                    const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
                    if (isPriceFacetApplied) {
                    // Find the parent element with the class kuFilterNames.kuFilterCollapse
                    const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);
        
                    if (nouiElement) {
                        const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);
        
                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }
        
                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);
        
                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);
        
                        // Rotate icon in the title
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }
                    }
                }
        
                // Function-helper to find the parent element with a specified class
                function findParentWithClass(element, className) {
                    let parent = element.parentElement;
                    while (parent) {
                        if (parent.matches(className)) {
                            return parent;
                        }
                        parent = parent.parentElement;
                    }
                    return null; // No matching parent found
                }
            },
            smoothScrollToProductListingTop: function () {
                let customOffset = 150;
                const selectorsToTriggerScrollToTop = {
                pagination: '.kuPagination a',
                // filterOptions: '.klevuFilterOption',
                // Add more selectors here as needed
                }
                function _smoothScrollToKlevuTop() {
                setTimeout(function () {
                    var target = document.getElementsByClassName('klevuMeta')[0];
        
                    if (target) {
                        var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
        
                        window.scrollTo({
                            top: topPosition - customOffset,
                            behavior: 'smooth'
                        });
                    }
                }, 200);
                }
                Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
                });
            },
            closeFilterOnOutsideClick: function (data, scope) {
                klevu.event.attach(document.body, "click", function (event) {
                    function hasSomeParentTheClass(element, classname) {

                        if (typeof element.className !== 'object' && typeof element.className !== 'undefined' && element.className.split(' ').indexOf(classname) >= 0) return true;
                        return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
                    }

                    if (!hasSomeParentTheClass(event.target, 'kuFilterBox')) {
                        klevu.each(klevu.dom.find(".kuFilterHead"), function (key, facet) {

                            //if (event.currentTarget.dataset.label !== facet.dataset.label) {
                            facet.classList.add('kuExpand');
                            facet.classList.remove('kuCollapse');
                            //}
                            facet.nextElementSibling.classList.remove("kuFilterCollapse");
                            facet.nextElementSibling.classList.add("kuFilterShowAll");
                        });

                        sessionStorage.removeItem('klv_filter');

                    }
                });
            },
            oneFacetIsOpened: function (data, scope) {
                klevu.each(klevu.dom.find(".kuFilterHead"), function (key, value) {
                    klevu.event.attach(value, "click", function (event) {
                        klevu.each(klevu.dom.find(".kuFilterHead"), function (key, facet) {
                            if (event.target.dataset.label !== facet.dataset.label) {
                                facet.classList.add('kuExpand');
                                facet.classList.remove('kuCollapse');
                            }
                            facet.nextElementSibling.classList.remove("kuFilterCollapse");
                            facet.nextElementSibling.classList.add("kuFilterShowAll");
                        });
                    });
                });
            },
            filterSortingMobileToggler: function (data, scope) {
                const documentBody = document.body;
        
                function clickHandler({ target }) {
                    if (target.matches('.ku-filterOpener, .ku-filterOpener *, .filters-close-btn, .filters-close-btn *')) {
                        documentBody.classList.toggle("klevu-filters-opened");
                    }
                    if (target.matches('.kuFilters .kuFilterBox, .kuFilters .kuFilterBox *')) {
                        documentBody.classList.remove('klevu-sorting-opened');
                    }
                }
                if (!documentBody.dataset.klevuMobileFiltersClickListenerAttached) {
                    klevu.event.attach(documentBody, "click", clickHandler);
                    documentBody.dataset.klevuMobileFiltersClickListenerAttached = "true"; // Set the data attribute - Mark the handler as attached
                }
            },
            addKlevuBodyClass: function () {
                document.body.classList.add('klevu-page');
            }
        });
    })(klevu);
});

klevu.modifyRequest("catnav,landing", function (data, scope) {
  // Restore Search Params On Page Load
  klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

  // set the global scope
  window.klevuCurrentScope = scope.kScope;

  // Set limits
  klevu.each(data.request.current.recordQueries, function (key, query) {
    const qid = klevu.getObjectPath(query, "id");

    if (qid === "productList") {
      // you already have these:
      klevu.setObjectPath(query, "settings.limit", 36);
      klevu.setObjectPath(data, "localOverrides.query.productList.settings.limit", 36);

      // --- NEW: raise facet option limits (covering different engine versions) ---
      klevu.setObjectPath(query, "settings.facetOptionsMaxCount", 500);
      klevu.setObjectPath(query, "settings.facets.maxValuesPerFacet", 500);
      klevu.setObjectPath(query, "settings.facets.maxCount", 500);
      klevu.setObjectPath(query, "filters.limit", 500);
      // If your response includes filtersToReturn, this also helps:
      klevu.setObjectPath(query, "filters.filtersToReturn.options.limit", 500);
    }

    if (qid === "noResultsFoundPopularProductList") {
      klevu.setObjectPath(query, "settings.limit", 12);
    }
  });
});


klevu.modifyRequest("landing,catnav", function(data, scope){
  klevu.each(data.request.current.recordQueries, function(key, query){
    klevu.setObjectPath(query, "filters.filtersToReturn.options.order", "INDEX");
  });
});



klevu.afterTemplateRender("catnav,landing", function (data, scope) {
    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    klevu.search.modules.collapseAllFilters();
    klevu.search.modules.smoothScrollToProductListingTop(data, scope);
    klevu.search.modules.filterSortingMobileToggler(data, scope);
    klevu.search.modules.addKlevuBodyClass();


    // mobile only
    if (scope.kScope.template.getHelpers().isScreenWidthSmaller()) {   
        klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);
    }

    // desktop  only
    if (!scope.kScope.template.getHelpers().isScreenWidthSmaller()) {
        klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);
        klevu.search.modules.closeFilterOnOutsideClick(data, scope);
        klevu.search.modules.oneFacetIsOpened(data, scope);
    }
// Desktop-only: show toggle only when facet is open; start collapsed; expand/collapse on click
if (!scope.kScope.template.getHelpers().isScreenWidthSmaller()) {
  var COLLAPSED_HEIGHT = '180px'; // adjust if you want more/less items visible

  document.querySelectorAll('.kuFilters .kuFilterNames').forEach(function (box) {
    var ul = box.querySelector('ul');
    if (!ul) return;

    // Only show a toggle if there are enough items
    var items = ul.querySelectorAll('li');
    if (items.length <= 6) return;

    // Ensure there is a toggle inside .kuFilterNames (standard Klevu placement)
    var toggle = box.querySelector('.kuShowOpt');
    if (!toggle) {
      toggle = document.createElement('div');
      toggle.className = 'kuShowOpt';
      toggle.tabIndex = -1;
      toggle.innerHTML = '<span class="ku-FilterShowMore">Show More</span><span class="ku-FilterShowLess">Show Less</span>';
      box.appendChild(toggle);
    }

    var facetBox = box.closest('.kuFilterBox');
    var head = facetBox && facetBox.querySelector('.kuFilterHead');
    if (!head) return;

    function setCollapsed() {
      // Klevu classes
      box.classList.add('kuFilterCollapse');
      box.classList.remove('kuFilterShowAll');
      // Guard against theme overflow on either container or UL
      box.style.maxHeight = '';
      box.style.overflow  = '';
      ul.style.maxHeight  = COLLAPSED_HEIGHT;
      ul.style.overflow   = 'hidden';
    }

    function setExpanded() {
      box.classList.remove('kuFilterCollapse');
      box.classList.add('kuFilterShowAll');
      // Remove any height clamps so full list shows
      box.style.maxHeight = '';
      box.style.overflow  = '';
      ul.style.maxHeight  = '';
      ul.style.overflow   = '';
    }

    // Bind toggle click once (this is what was missing)
    if (!toggle.dataset.bound) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (box.classList.contains('kuFilterCollapse')) setExpanded();
        else setCollapsed();
      });
      toggle.dataset.bound = '1';
    }

    // Show/hide the toggle based on facet accordion open/close,
    // and on FIRST open start in collapsed state.
    function syncOnHeaderToggle() {
      var facetIsOpen = !head.classList.contains('kuExpand'); // 'kuExpand' = closed
      // show toggle only when facet is open (inline to beat theme CSS)
      toggle.style.setProperty('display', facetIsOpen ? 'block' : 'none', 'important');

      if (facetIsOpen && !box.dataset.klevuInit) {
        setCollapsed();                 // start collapsed the first time it opens
        box.dataset.klevuInit = '1';
      }
    }

    if (!head.dataset.klevuWatcher) {
      head.addEventListener('click', function () {
        setTimeout(syncOnHeaderToggle, 0); // wait for Klevu to flip classes
      });
      head.dataset.klevuWatcher = '1';
    }

    // Initial sync (covers already-open facets)
    syncOnHeaderToggle();
  });
}

/* =========================
   Klevu → Theme Quick Buy (stable close wiring)
   ========================= */

(function KlevuQuickBuyBridge(){
  if (window.__KLEVU_QB_BRIDGE__) return;
  window.__KLEVU_QB_BRIDGE__ = true;

  // ---------- Helpers ----------
  function handleFromUrl(url){
    var m = (url || '').match(/\/products\/([^\/\?#]+)/i);
    return m ? m[1] : '';
  }

  function ensureModal(){
    // Prefer existing theme modal, else create one host
    var modal = document.querySelector('quick-buy-modal') || document.getElementById('klevu-quick-buy-modal');
    if (!modal) {
      modal = document.createElement('quick-buy-modal');
      modal.id = 'klevu-quick-buy-modal';
      modal.className = 'quick-buy-modal modal';
      modal.setAttribute('role','dialog');
      modal.setAttribute('aria-modal','true');
      modal.style.zIndex = '100010';
      document.body.appendChild(modal);
    }
    return modal;
  }

  async function fetchQuickBuyTemplate(handle){
    const candidates = [
      `/products/${handle}?view=quick-buy`,
      `/products/${handle}`
    ];
    for (let i = 0; i < candidates.length; i++){
      try {
        const res = await fetch(candidates[i], { credentials:'same-origin' });
        if (!res.ok) continue;
        const html = await res.text();
        const doc  = new DOMParser().parseFromString(html, 'text/html');
        const tpl  = doc.querySelector('template#quick-buy-content');
        if (tpl) return tpl;
      } catch(_) {}
    }
    return null;
  }

  // Fallback shell only if the theme custom element isn't registered
  function ensureFallbackShell(){
    let shell = document.getElementById('klevu-qb-fallback');
    if (!shell) {
      shell = document.createElement('div');
      shell.id = 'klevu-qb-fallback';
      shell.innerHTML =
        '<div id="klevu-qb-backdrop"></div>' +
        '<div id="klevu-qb-panel" role="dialog" aria-modal="true">' +
          '<button id="klevu-qb-close" aria-label="Close">×</button>' +
          '<div id="klevu-qb-body"></div>' +
        '</div>';
      document.body.appendChild(shell);
      shell.addEventListener('click', function(e){
  const hitClose =
    e.target.id === 'klevu-qb-backdrop' ||
    e.target.id === 'klevu-qb-close' ||
    e.target.closest('dialog-close-button, .quick-buy-modal__close-button, [aria-label="Close"]');

  if (!hitClose) return;

  e.preventDefault();
  e.stopPropagation();

  shell.classList.remove('is-open');
  document.documentElement.classList.remove('qb-open');
});

    }
    return shell;
  }

  async function fallbackOpen(handle){
  // ✅ Do nothing if the native modal is already open
  if (document.querySelector('quick-buy-modal[open], #klevu-quick-buy-modal[open]')) return;

  const shell = ensureFallbackShell();
  const body  = shell.querySelector('#klevu-qb-body');
  body.innerHTML = '';

  const tpl = await fetchQuickBuyTemplate(handle);
  if (tpl && tpl.content && tpl.content.children.length) {
    body.appendChild(tpl.content.cloneNode(true));
    shell.classList.add('is-open');
    document.documentElement.classList.add('qb-open');
    return;
  }
  const iframe = document.createElement('iframe');
  iframe.src = `/products/${handle}?view=quick-buy`;
  iframe.style.width = '100%';
  iframe.style.height = '80vh';
  iframe.style.border = '0';
  body.appendChild(iframe);
  shell.classList.add('is-open');
  document.documentElement.classList.add('qb-open');
}


  function once(el, type, fn){
    const h = function(ev){ el.removeEventListener(type, h); fn(ev); };
    el.addEventListener(type, h);
  }

  function wireClose(modal, closeFn){
    // 1) Esc to close (bound once)
    if (!window.__qbEscBound) {
      window.__qbEscBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeFn();
      });
    }

    // 2) Click-outside: clicking the host closes (bound once)
    if (!window.__qbBackdropBound) {
      window.__qbBackdropBound = true;
      document.addEventListener('click', (e) => {
        const openEl = document.querySelector('quick-buy-modal[open], #klevu-quick-buy-modal[open]');
        if (!openEl) return;
        if (e.target === openEl) closeFn();
      });
    }

    // 3) Use ONLY the theme’s native close. Never inject our own.
    setTimeout(() => {
      // remove any leftover fallback X from previous tests
      modal.querySelectorAll('.qb-close-fallback').forEach(n => n.remove());

      // bind theme close
      const themeBtn = modal.querySelector(
        '.quick-buy-modal__close-button, dialog-close-button [type="button"], [data-action="close"]'
      );
      if (themeBtn && !themeBtn.__qbBound) {
        themeBtn.__qbBound = true;
        themeBtn.addEventListener('click', function(ev){
          ev.preventDefault(); ev.stopPropagation();
          closeFn();
        }, { passive:true });
      }
    }, 150);
  }

  async function openQuickBuy(handle){
    if (!handle) return;

    // Prevent opening again while already open
    if (document.querySelector('quick-buy-modal[open], #klevu-quick-buy-modal[open], #klevu-qb-fallback.is-open')) {
      return;
    }

    const modal = ensureModal();
    document.documentElement.classList.add('qb-open');

    const closeFn = function(){
      // close theme modal if open
      const openEl = document.querySelector('quick-buy-modal[open], #klevu-quick-buy-modal[open]');
      if (openEl) {
        openEl.removeAttribute('open');
        if (typeof openEl.close === 'function') { try { openEl.close(); } catch(_){} }
      }
      // close fallback if open
      const fb = document.getElementById('klevu-qb-fallback');
      if (fb) fb.classList.remove('is-open');

      document.documentElement.classList.remove('qb-open');
    };

    try {
      const tpl = await fetchQuickBuyTemplate(handle);
      if (!tpl) throw new Error('No <template id="quick-buy-content"> found');

      modal.innerHTML = '';
      modal.appendChild(tpl.cloneNode(true));
      modal.setAttribute('open', '');

      // keep fallback fully out of sight if it existed before
      const fbShell = document.getElementById('klevu-qb-fallback');
      if (fbShell) fbShell.classList.remove('is-open');

      wireClose(modal, closeFn);

      // ✅ Only use native if it actually rendered visible content.
// If not, close native and fail over to fallback (single layer only).
setTimeout(() => {
  // “Rendered” = has expected nodes AND occupies space
  const content = modal.querySelector(
    '.quick-buy-modal__content, product-rerender, #quick-buy-modal-content, .product-info, form.shopify-product-form'
  );

  let painted = false;
  if (content) {
    try {
      const r = content.getBoundingClientRect();
      const cs = window.getComputedStyle(content);
      painted = r.width > 10 && r.height > 10 && cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity || '1') > 0.01;
    } catch (_) {}
  }

  if (!painted) {
    // close native, then use fallback
    modal.removeAttribute('open');
    const fb = document.getElementById('klevu-qb-fallback');
    if (fb) fb.classList.remove('is-open'); // ensure clean state
    fallbackOpen(handle);
  } else {
    // native is fine—ensure fallback is shut
    const fb = document.getElementById('klevu-qb-fallback');
    if (fb) fb.classList.remove('is-open');
  }
}, 200);


      window.__klevuQBModal = modal;
    } catch(_) {
      fallbackOpen(handle);
    }
  }

  // ---------- Click binding (capture phase) ----------
  if (!window.__klevuQBClickBound) {
    window.__klevuQBClickBound = true;
    document.addEventListener('click', function(e){
      var btn = e.target.closest('.klevu-qb-trigger');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var handle = handleFromUrl(btn.getAttribute('data-product-url'));
      if (handle) openQuickBuy(handle);
    }, true);
  }

  // ---------- State guard ----------
  (function qbStateGuard(){
    if (window.__qbStateGuardBound) return;
    window.__qbStateGuardBound = true;

    const html = document.documentElement;
    function updateState() {
      const anyOpen = !!document.querySelector('quick-buy-modal[open], #klevu-quick-buy-modal[open], #klevu-qb-fallback.is-open');
      html.classList.toggle('qb-open', anyOpen);
    }
    const mo = new MutationObserver(updateState);
    mo.observe(document.documentElement, { subtree:true, childList:true, attributes:true, attributeFilter:['open','class'] });
    updateState();

    window.__qbCloseAll = function(){
      document.querySelectorAll('quick-buy-modal[open], #klevu-quick-buy-modal[open]').forEach(el => el.removeAttribute('open'));
      const fb = document.getElementById('klevu-qb-fallback');
      if (fb) fb.classList.remove('is-open');
      updateState();
    };
  })();

  /* -------- ONLY ADDITION: force the theme's native X to close --------
     Works even if the X lives in a shadow DOM. Does nothing else. */
  (function bindNativeXForceClose(){
    if (window.__qbForceCloseBound) return;
    window.__qbForceCloseBound = true;

    document.addEventListener('click', function(e){
      // composedPath lets us detect clicks inside shadow DOM
      const path = (e.composedPath && e.composedPath()) || [];
      // Did the click go through a native close control?
      const hitNativeClose = path.some(function(el){
        if (!el || !el.matches) return false;
        return el.matches(
          'dialog-close-button, dialog-close-button *, .quick-buy-modal__close-button, ' +
          '[data-action="close"], button[aria-label="Close"]'
        );
      });
      if (!hitNativeClose) return;

      // Find the modal host in the path
      const host = path.find(function(el){
        return el && el.matches && el.matches('quick-buy-modal, #klevu-quick-buy-modal');
      });
      if (!host) return;

      // Close cleanly (no other page changes)
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      host.removeAttribute('open');
      if (typeof host.close === 'function') { try { host.close(); } catch(_){} }
      document.documentElement.classList.remove('qb-open');
    }, true); // capture
  })();

})();
/* Make the visible "X" close, whether we're on the native modal or the fallback */
(function bindJustThatClose(){
  if (window.__qbJustThatClose) return;
  window.__qbJustThatClose = true;

  // 1) Fallback shell: close when the header X is clicked
  document.addEventListener('click', function(e){
    const btn = e.target.closest('#klevu-qb-fallback .quick-buy-modal__close-button, #klevu-qb-fallback dialog-close-button');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const shell = document.getElementById('klevu-qb-fallback');
    if (shell) shell.classList.remove('is-open');
    document.documentElement.classList.remove('qb-open');
  }, true);

  // 2) Native theme modal: close when the header X is clicked
  document.addEventListener('click', function(e){
    const btn = e.target.closest('quick-buy-modal .quick-buy-modal__close-button, quick-buy-modal dialog-close-button');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const host = btn.closest('quick-buy-modal, #klevu-quick-buy-modal');
    if (host) host.removeAttribute('open');
    document.documentElement.classList.remove('qb-open');
  }, true);
})();

/* FINAL fallback closer — closes the fallback shell on any real "X" click (shadow-DOM safe) */
(function qbFinalFallbackCloser(){
  if (window.__qbFinalFallbackCloserBound) return;
  window.__qbFinalFallbackCloserBound = true;

  // Close on click of: backdrop, our fallback X, or the header X inside the cloned template
  document.addEventListener('click', function(e){
    const shell = document.getElementById('klevu-qb-fallback');
    if (!shell || !shell.classList.contains('is-open')) return;

    // Inspect through shadow DOM
    const path = (e.composedPath && e.composedPath()) || [e.target];

    const hit = path.some(function(el){
      if (!el || !el.matches) return false;
      // backdrop, our fallback X
      if (el.id === 'klevu-qb-backdrop' || el.id === 'klevu-qb-close') return true;
      // theme header close inside the cloned quick-buy content
      return el.matches('dialog-close-button, dialog-close-button *, .quick-buy-modal__close-button, [aria-label="Close"]');
    });

    if (!hit) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    shell.classList.remove('is-open');
    document.documentElement.classList.remove('qb-open');
  }, true);

  // Also allow ESC to close the fallback if it’s showing
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    const shell = document.getElementById('klevu-qb-fallback');
    if (!shell || !shell.classList.contains('is-open')) return;
    shell.classList.remove('is-open');
    document.documentElement.classList.remove('qb-open');
  }, true);
})();
// Close the fallback shell when its own X is clicked (works even if an iframe is inside)
(function bindFallbackCloseOnly(){
  if (window.__qbFallbackCloseOnly) return;
  window.__qbFallbackCloseOnly = true;

  document.addEventListener('click', function(e){
    const btn = e.target.closest('#klevu-qb-close');
    if (!btn) return;

    const shell = document.getElementById('klevu-qb-fallback');
    if (shell && shell.classList.contains('is-open')) {
      e.preventDefault(); e.stopPropagation();
      shell.classList.remove('is-open');
      document.documentElement.classList.remove('qb-open');
    }
  }, true);
})();




});

window.onpopstate = function (event) {
    try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
        // code to get ready to reset all the data
        var data = window.klevuCurrentScope.element.kObject.getScope().data;
        var scope = window.klevuCurrentScope.element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;

        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

        // Fire request, re-render results
        klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
    } catch (error) {
        console.log(error)
    }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateResultsCustom = `
<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">                                
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>

                            <button class="ku-filterOpener">
                                <span>
                                    Filter & Sort
                                </span>
                            </button>

                        <% if(helper.hasResults(data,"productList")) { %>
                            <%=helper.render('sortBy',scope,data,"productList") %>
                        <% } %>
                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                </div>
                <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">        
                    <header ku-block data-block-id="ku_landing_result_header">
                        <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                        <%=helper.render('filtersTop',scope,data,"productList") %>
                        <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                        <% if(helper.hasResults(data,"productList")) { %>
                            <%=helper.render('limit',scope,data,"productList") %>
                            <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                        <% } %>
                        <div class="kuClearBoth"></div>
                    </header>

                    <div ku-block data-block-id="ku_landing_result_items">
                        <div class="kuResults">
                            <% if(helper.hasResults(data,"productList")) { %>
                                <ul>
                                    <% helper.each(data.query.productList.result,function(key,item){ %>
                                        <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                            <%=helper.render('productBlock',scope,data,item) %>
                                        <% } %>
                                    <% }); %>
                                </ul>
                            <% } else { %>
                                <div class="kuNoRecordsFoundLabelTextContainer">
                                    <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                </div>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </div>

                    </div>
                    
                    <div ku-block data-block-id="ku_landing_other_items">
                        <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                    </div>
                    <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                </section>
                <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                    <div ku-block data-block-id="ku_landing_right_facets"></div>
                    <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                    <div ku-block data-block-id="ku_landing_right_banner"></div>
                </section>
            </div>

            <%=helper.render('pagination',scope,data,"productList") %>
            
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                
                                <%=helper.render('filters',scope,data,"contentList") %>

                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                <% if(helper.hasResults(data,"contentList")) { %>
                                <!-- RICO: Removed non-product results -->
                                        <ul>                                        
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                        <!--
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
                <% if(helper.hasResults(data,"contentList")) { %>
                    <%=helper.render('pagination',scope,data,"contentList") %>
                <% } %>
            </div>
        </div>
    <% } %> 
</div>`;

var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
<%
    var resultsPerPage = data.query[dataLocal].meta.noOfResults;
    var totalResultsFound = data.query[dataLocal].meta.totalResultsFound - 1;
    const lastPageOffset = (Math.floor(totalResultsFound/resultsPerPage)*resultsPerPage);
    const currentOffset = data.query[dataLocal].meta.offset;
    const productListLimit = data.query.productList.meta.noOfResults;
    const currentPage = (Math.ceil(currentOffset/resultsPerPage)+1);
    const customOffsetPrev = currentOffset - productListLimit;
    const customOffsetNext = (currentOffset + (resultsPerPage)) >= lastPageOffset ? lastPageOffset : (currentOffset + (resultsPerPage));
    const customOffsetPrevTotRes = currentPage <= 1 ? 1 : (productListLimit * (currentPage - 1));
    const totalPages = (Math.ceil(totalResultsFound/resultsPerPage));
    const isLastPage = currentPage === totalPages;
    const productListTotal = data.query.productList.meta.totalResultsFound - 1;
    const lastPage = (Math.ceil(productListTotal/productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal/productListLimit)) : 0;
    const toProducts = data.query.productList.meta.offset+productListLimit >= productListTotal ? productListTotal : data.query.productList.meta.offset+productListLimit;
    const arrowRightSVG = '<svg width="21" height="20" xmlns="http://www.w3.org/2000/svg"><path d="M13.212 5.592a.83.83 0 0 0-1.175 0L8.212 9.417a.83.83 0 0 0 0 1.175l3.825 3.825a.83.83 0 1 0 1.175-1.175L9.978 10l3.234-3.233a.838.838 0 0 0 0-1.175z" fill="#B2B2B2" fill-rule="evenodd"/></svg>'; 
%>

<div class="kuPagination kuPagination--custom">

    <div class="klevuPaginate-wrapper">

        <% if(currentOffset > 0) { %>
            <a target="_self" href="javascript:void(0)"  class="klevuPaginate klevuPaginate_prev" rel="prev" data-offset="<%= customOffsetPrev %>">&lt;</a>
        <% } %>

        <% if (currentPage === 2) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
        <% } %>
        <% if (currentPage >= 3) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)-1)%></a>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
        <% } %>

        <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(currentOffset/resultsPerPage)+1)%></a>



        <% if(totalResultsFound >= currentOffset + resultsPerPage) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage)+2)%></a>
        <% } %>
        <% if (totalPages - currentPage === 2) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
        <% } %>
        <% if (totalPages - currentPage >= 3) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
        <% } %>
        <% if (totalPages - currentPage >= 4) { %>
            <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+4)%></a>
        <% } %>

        <% if(totalResultsFound >= currentOffset + resultsPerPage && totalPages > 3) { %>
            <a target="_self" href="javascript:void(0)" rel="next" class="klevuPaginate klevuPaginate_next" data-offset="<%=customOffsetNext%>">&gt;</a>
        <% } %>

    </div>
</div>

<% } %>`;

var klevuLandingTemplateProductBlockCustom = `
<% 
    var updatedProductName = dataLocal.name;
    if(klevu.search.modules.kmcInputs.base.getSkuOnPageEnableValue()) {
        if(klevu.dom.helpers.cleanUpSku(dataLocal.sku)) {
            updatedProductName += klevu.dom.helpers.cleanUpSku(dataLocal.sku);
        }
    }
%>
<li ku-product-block class="klevuProduct" data-id="<%=dataLocal.id%>">
    <div class="kuProdWrap">
        <header ku-block data-block-id="ku_landing_result_item_header">
            <%=helper.render('landingProductBadge', scope, data, dataLocal) %>
        </header>
        <% var desc = [dataLocal.summaryAttribute,dataLocal.packageText,dataLocal.summaryDescription].filter(function(el) { return el; }); desc = desc.join(" "); %>
        <main ku-block data-block-id="ku_landing_result_item_info">
            <div class="kuProdTop">
                <div class="klevuImgWrap">
                    <a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView">
                        <img src="<%=dataLocal.image.replace('_medium', '_500x500')%>" origin="<%=dataLocal.image.replace('_medium', '_500x500')%>" onerror="klevu.dom.helpers.cleanUpProductImage(this)" alt="<%=updatedProductName%>" class="kuProdImg">
                        <%=helper.render('landingImageRollover', scope, data, dataLocal) %>
                    </a>
                                    <!-- Quick View button -->
                            <button
                                type="button"
                                class="klevu-qb-trigger kuQuickViewBtn"
                                data-product-url="<%= dataLocal.url %>"
                                aria-label="Quick view">
                            </button>

                       
                </div>
                <!-- <div class="kuQuickView">
                    <button data-id="<%=dataLocal.id%>" class="kuBtn kuBtnLight kuQuickViewBtn" role="button" tabindex="0" area-label="">Quick view</button>
                </div> -->
            </div>
            
        </main>
        <footer ku-block="" data-block-id="ku_landing_result_item_footer">
            <div class="kuProdBottom">
            <!-- START OF CUSTOMIZATION - RICO PRODUCT FLAGS -->
                    <div class="kuProdAdditionalBottomLeft">
                    <% if (typeof dataLocal.tags === 'string') { 
                        var tags = dataLocal.tags.split(',').map(function(tag){ return tag.toLowerCase().trim(); });
                        var tagDisplayed = false;
                    %>

                        <% if (tags.includes("new arrivals") && !tagDisplayed) { %>
                        <span class="custom-tag-badge">New!</span>
                        <% tagDisplayed = true; %>
                        <% } %>

                        <% if (tags.includes("exclusive") && !tagDisplayed) { %>
                        <span class="custom-tag-badge">FAO Exclusive</span>
                        <% tagDisplayed = true; %>
                        <% } %>

                        <% if (tags.includes("movingfast") && !tagDisplayed) { %>
                        <span class="custom-tag-badge">Selling Quickly!</span>
                        <% tagDisplayed = true; %>
                        <% } %>

                        <% if (tags.includes("best seller") && !tagDisplayed) { %>
                        <span class="custom-tag-badge">Best Seller</span>
                        <% tagDisplayed = true; %>
                        <% } %>

                        <% if (tags.includes("backinstock") && !tagDisplayed) { %>
                        <span class="custom-tag-badge">Back in Stock</span>
                        <% tagDisplayed = true; %>
                        <% } %>

                        <% } %>
                    </div> 
           
    <% if (typeof dataLocal.brand !== 'undefined' && dataLocal.brand !== '') { %>
        <div class="klevu-brand"><%= dataLocal.brand %></div>
    <% } %>              
                <div class="kuName kuClippedOne"><a data-id="<%=dataLocal.id%>" href="<%=dataLocal.url%>" class="klevuProductClick kuTrackRecentView" title="<%= updatedProductName %>"><%= updatedProductName %></a></div>
                <% if(dataLocal.inStock && dataLocal.inStock != "yes") { %>
                    <%=helper.render('landingProductStock', scope, data, dataLocal) %>              
                <% } else { %>
                    <% if (klevu.search.modules.kmcInputs.base.getShowPrices()) { %>
                    <div class="kuPrice">
                        <%
                            var kuTotalVariants = klevu.dom.helpers.cleanUpPriceValue(dataLocal.totalVariants);
                            var kuSalePrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.salePrice,dataLocal.currency);
                            var kuPrice = klevu.dom.helpers.cleanUpPriceValue(dataLocal.price,dataLocal.currency);
                        %>
                        <% if (!Number.isNaN(kuSalePrice) && !Number.isNaN(kuPrice) && kuPrice > kuSalePrice) { %>
                            <% let discount = Math.round(100 - (100 * Number(dataLocal.salePrice)) / Number(dataLocal.price)); %>
                            <span class="kuOrigPrice kuClippedOne">
                                <%= helper.processCurrency(dataLocal.currency, parseFloat(dataLocal.price)) %>
                            </span>
                            <span class="kuSalePrice kuSpecialPrice kuClippedOne">
                                <% if (!Number.isNaN(kuTotalVariants)) { %><%=helper.translate("Starting at")%><% } %>
                                <%= helper.processCurrency(dataLocal.currency, parseFloat(dataLocal.salePrice)) %>
                            </span>
                            <span class="klevu-discount">(<%=helper.translate("Save")%> <%= discount %>%)</span>
                        <% } else if(!Number.isNaN(kuSalePrice)) { %>
                            <span class="kuSalePrice kuSpecialPrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.salePrice)) %>
                            </span>
                        <% } else if(!Number.isNaN(kuPrice)) { %>
                            <span class="kuSalePrice">
                                <%= helper.processCurrency(dataLocal.currency,parseFloat(dataLocal.price)) %>
                            </span>
                        <% } %>
                        <%=helper.render('searchResultProductVATLabel', scope, data, dataLocal) %>
                    </div>
                <% } %>
                <% } %>
            </div>



            <div class="kuProdAdditional">
                <div class="kuProdAdditionalData">                
                    <% if(desc && desc.length) { %>
                        <div class="kuDesc kuClippedTwo"> <%=desc%> </div>
                    <% } %>
                    <%=helper.render('landingProductSwatch',scope,data,dataLocal) %>
                    <%=helper.render('klevuLandingProductRating',scope,data,dataLocal) %>
                    <% var isAddToCartEnabled = klevu.search.modules.kmcInputs.base.getAddToCartEnableValue(); %>
                    <% if(isAddToCartEnabled) { %>
                        <%=helper.render('landingPageProductAddToCart',scope,data,dataLocal) %> 
                    <% } %>
                </div>
            </div>
        </footer>             
    </div>
</li>`;

var klevuLandingTemplateFiltersCustom = `
<% if(data.query[dataLocal].filters.length > 0 ) { %>
    <div class="ku-mobFilterWrapper">

        <div class="klevu-filters-header">
            <h4 class="filters-title">Filter & Sort</h4>
            <a class="filters-close-btn">
                <svg class="ss__icon ss__icon--close-thin ss-1v72vbw" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg" width="12px" height="12px"><path d="M56 5.638l-22.362 22.362 22.362 22.362-5.638 5.638-22.362-22.362-22.362 22.362-5.638-5.638 22.362-22.362-22.362-22.362 5.638-5.638 22.362 22.362 22.362-22.362z"></path></svg>
            </a>
        </div>
        <%=helper.render('sortBy',scope,data,"productList") %>

    <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
        <h3 class="kuFiltersTitleHeading"><%=helper.translate("Narrow by")%></h3>
        <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>

            <% var optionCounter = 0; %>
            <% if(filter.type == "OPTIONS"){ %>
                <% 
                if (!filter.options.length) return; 
                %>

                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>" data-label="<%= filter_label %>">
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                    >
                                    <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text"><%=filterOption.name%></span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                        <% if(filter.options.length > 6) { %>
                            <div class="kuShowOpt" tabindex="-1">
                                <span class="ku-FilterShowMore"> <span class="klevu-icon-wrapper"><svg class="klevu-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><path d="M56 31.946h-24.054v24.054h-7.893v-24.054h-24.054v-7.893h24.054v-24.054h7.893v24.054h24.054v7.893z"></path></svg></span>Show More</span>
                                <span class="ku-FilterShowLess"> <span class="klevu-icon-wrapper"><svg class="klevu-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><path d="M0 23.297h56v9.406h-56v-9.406z"></path></svg></span> Show Less</span>
                            </div>
                        <% } %>
                    </div>
                </div>
            <% } else if(filter.type == "SLIDER")  { %>
                <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                        <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                            <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                        </div>
                    </div>
                </div>
            <% } else if (filter.type == "RATING")  { %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <%=helper.translate(filter.label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text">
                                            <div class="klevuFacetStars">
                                                <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                            </div>
                                        </span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                    </div>
                </div>
            <% } else { %>
                <!-- Other Facets -->
            <% } %>
        <% }); %>
        <!-- <div class="kuFiltersFooter">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
        </div> -->
    </div>
    </div>
<% } %>`;

var landingPageProductColorSwatchesCustom = `
<%  
    var hasAnyVariantImageAdded = false;
    if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length) {
        helper.each(dataLocal.swatchesInfo,function(key,item) {
            if(item.variantImage && item.variantImage.length) {
                hasAnyVariantImageAdded = true;
            }
        });
    }
%>

<% if(((!dataLocal.swatchesInfo || !dataLocal.swatchesInfo.length) || !hasAnyVariantImageAdded) && dataLocal.totalVariants) { %>
    <div class="kuSwatches">
        <span class="kuSwatchesVariantCountText">+<%= dataLocal.totalVariants %> <%= helper.translate("more") %></span>
    </div>
<% } %>

<% if(dataLocal.swatchesInfo && dataLocal.swatchesInfo.length && hasAnyVariantImageAdded) { %>
    <div class="kuSwatches">
        <% 
            var totalVariantIndex = dataLocal.swatchesInfo.length;
            var swatchIndex = 0;
            helper.each(dataLocal.swatchesInfo,function(key,item) {
                var isSwatchInfoAdded = false;
                if(swatchIndex > 2){ return true; }
                if(item.variantImage && item.variantImage.length) {
        %>

                        <div class="kuSwatchItem">
                            <a 
                                target="_self" 
                                href="javascript:void(0)" 
                                data-variant="<%= item.variantId %>" 
                                class="kuSwatchLink klevuLandingSwatchColorGrid"
                                <% if(item.variantColor && item.variantColor.length) { %>
                                    title="<%= item.variantColor %>"
                                <% } %>
                                style="<% if(item.variantColor && item.variantColor.length) { isSwatchInfoAdded = true; %>
                                        background:<%= item.variantColor %>;
                                    <% } %>
                                    <% if(item.variantSwatchImage && item.variantSwatchImage.length) { isSwatchInfoAdded = true; %>
                                        background-image: url('<%= item.variantSwatchImage %>');
                                    <% } %>
                                    <% if(!isSwatchInfoAdded) {  %>
                                        background-image: url('https://js.klevu.com/klevu-js-v1/img-1-1/default-swatch.jpg');
                                    <% } %>"
                            >
                            </a>
                        </div>

        <%          
                    swatchIndex++;
                }                    
            });
        %>

        <% if(totalVariantIndex > swatchIndex) { %>
            <div class="kuSwatchItem kuSwatchMore">
                <div class="kuSwatchLink">
                    <span class="kuSwatchMoreText">
                        +<%= (totalVariantIndex - swatchIndex) %> more
                    </span>
                </div>
            </div>
        <% } %>

   </div>	
<% } %>`;

//RICO CUSTOMIZATIONS

var klevuLandingTemplateSortByCustom = `
<div class="kuDropdown kuDropSortBy" role="listbox">
    <div class="kuDropdownLabel"><%=helper.translate("Sort by")%></div>
    <div class="kuDropdownOptions">
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Relevance'){ %> active<% } %>" data-value="RELEVANCE" role="option"><%=helper.translate("Relevance")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Price: Low to high'){ %> active<% } %>" data-value="PRICE_ASC" role="option"><%=helper.translate("Price: Low to high")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Price: High to low'){ %> active<% } %>" data-value="PRICE_DESC" role="option"><%=helper.translate("Price: High to low")%></div>
        <!-- new ones -->
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Name: A to Z'){ %> active<% } %>" data-value="NAME_ASC" role="option"><%=helper.translate("Name: A to Z")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Name: Z to A'){ %> active<% } %>" data-value="NAME_DESC" role="option"><%=helper.translate("Name: Z to A")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Newest First'){ %> active<% } %>" data-value="NEW_ARRIVAL_DESC" role="option"><%=helper.translate("Newest First")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Oldest First'){ %> active<% } %>" data-value="NEW_ARRIVAL_ASC" role="option"><%=helper.translate("Oldest First")%></div>
    </div>
</div>`;

